import LeadCaptureForm from '../blocks/LeadCaptureForm'
import { ASSET_URL } from '@telesoft/lib/web/constants'
import { Form, Page } from '@telesoft/types/payload-types'
import React, { ReactElement } from 'react'

export type LeadCaptureProps = Extract<Page['blocks'][0], { blockType: 'lead-capture' }>

export default function LeadCapture(block: LeadCaptureProps): ReactElement {
  const { options, video } = block

  return (
    <div
      className={`min-h-screen flex flex-col justify-center items-center relative bg-heading ${
        options?.padding ? 'py-24' : 'py-0'
      } overflow-hidden`}
    >
      {options?.darken && <div className="absolute inset-0 bg-heading"></div>}
      <div className="absolute inset-0 bg-telesoft mix-blend-soft-light"></div>
      <div className="absolute inset-0 opacity-40">
        <video
          id="vid"
          loop
          autoPlay
          playsInline
          muted
          width="100%"
          className="object-cover"
          height="100%"
        >
          <source
            src={`${
              video?.filename
                ? ASSET_URL + '/' + video.filename
                : '/assets/video/telesoft-home-hero-bg.mp4'
            }`}
            type="video/mp4"
          />
          Your browser does not support the video tag.
        </video>
      </div>
      <LeadCaptureForm {...block} />
    </div>
  )
}
